const baseurl = process.env.REACT_APP_API_URL || "https://easytenderbe.vercel.app"

export { baseurl }
